import React from "react";
import { Link, RichText } from "prismic-reactjs";
import linkResolver from "../helpers/linkResolver";
import isValidLink from "../helpers/isValidLink";

export default function RenderTextImageSection(slice) {
  const backgroundStyle = {
    background: slice.primary.background_color,
    color: slice.primary.text_color,
  };

  const sectionAlignment = slice.primary.section_alignment;
  const fullWidth = slice.primary.full_width;
  const ctaText = slice.primary.cta_text;
  const ctaLink = slice.primary.cta_link;
  const ctaText2 = slice.primary.cta_text_2;
  const ctaLink2 = slice.primary.cta_link_2;

  return (
    <section
      className="text-image-section gray-headlines-and-copy animate custom-animation"
      style={backgroundStyle}
    >
      <div className={`wrapper ${fullWidth === "Yes" && "full-width"}`}>
        <div
          className={`flex-wrapper ${
            sectionAlignment === "Image / Content" && "lead-image"
          }`}
        >
          <div className="content-wrapper standard-padding">
            <div className="content-wrapper-inner">
              <RichText render={slice.primary.content} />

              {isValidLink(ctaLink, ctaText) && (
                <div
                  className={`button-wrapper ${slice.primary.cta_alignment}`}
                >
                  <a
                    href={Link.url(ctaLink, linkResolver)}
                    className={`button solid-black`}
                    target={ctaLink.target}
                  >
                    {ctaText[0].text}
                  </a>
                </div>
              )}

              {isValidLink(ctaLink2, ctaText2) && (
                <div
                  className={`button-wrapper ${slice.primary.cta_alignment}`}
                >
                  <a
                    href={Link.url(ctaLink2, linkResolver)}
                    className={`button solid-black`}
                    target={ctaLink2.target}
                  >
                    {ctaText2[0].text}
                  </a>
                </div>
              )}
            </div>
          </div>

          {slice.primary.image.url && (
            <div className="image-wrapper">
              <img src={slice.primary.image.url} alt="Featured" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
